/**
 * Represents a DigitalPay Payment Error Associated With A Payment Instrument Id.
 */
class DigitalPayPaymentErrorState {
    constructor(key, state) {
        this.key = key;
        this.state = state;
    }
}

module.exports = DigitalPayPaymentErrorState;



// WEBPACK FOOTER //
// ./src/digitalpay/services/digital-pay-payment-error-state.js